var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._g(_vm._b({staticClass:"block text-gray-500 font-semibold text-sm text-left mb-2 cursor-pointer"},'label',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }